import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
//import $ from 'jquery';
import './Home.css';
import "owl.carousel/dist/assets/owl.carousel.css"; // Owl Carousel CSS
import "owl.carousel/dist/assets/owl.theme.default.css"; // Owl Carousel Theme CSS
import AlumniSays from "./AlumniSays";

const api_url = process.env.REACT_APP_API_URL;

const Home = () => {
  const [sliders, setSliders] = useState([]);

  // Fetch slider data from the API
  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await axios.get(`${api_url}/home_slider.php`);
        setSliders(response.data);  // Save the fetched data in state
      } catch (error) {
        console.error("Error fetching sliders:", error);
      }
    };

    fetchSliders();
  }, []);  // Empty dependency array to run once when the component mounts

  // Initialize the Owl Carousel once the sliders are loaded
  useEffect(() => {
    if (sliders.length > 0 && window.$) {
      // Initialize Owl Carousel after the sliders data is loaded
      window.$(".header-carousel").owlCarousel({
        autoplay: true,
        smartSpeed: 1500,
        items: 1,
        dots: true,
        loop: true,
        nav: false,
      });
    }
  }, [sliders]);  // Re-run when sliders state changes


  useEffect(() => {

    // Initialize Owl Carousel after the sliders data is loaded
    window.$(".team-carousel").owlCarousel({
      autoplay: true,
      smartSpeed: 1000,
      center: true,
      margin: 24,
      dots: true,
      loop: true,
      nav: false,
      responsive: {
        0: {
          items: 1
        },
        450: {
          items: 2
        },
        650: {
          items: 3
        },
        992: {
          items: 4
        }
      }
    });

  }, []);  // Re-run when sliders state changes

  return (
    <>
      <div className="container-fluid p-0 mb-5">
        {/* Only render the carousel if we have data */}
        {sliders.length > 0 && (

          <div className="owl-carousel header-carousel position-relative">
            {sliders.map((slider) => (

              <div key={slider.sl_id} className="owl-carousel-item position-relative">
                <img
                  className="img-fluid"
                  src={`https://demo.kvbalumni.org/assets/${slider.sl_img_url}`}
                  alt={slider.sl_head_text}
                  width="100%"
                  height="auto"
                />


                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
                  style={{ background: 'rgba(24, 29, 56, .7)' }}
                >
                  <div className="container">
                    <div className="row justify-content-start">
                      <div className="col-sm-10 col-lg-8">
                        <h1 className="display-3 text-white animated slideInDown">
                          {slider.sl_head_text}
                        </h1>
                        <p className="fs-5 text-white mb-4 pb-2">
                          {slider.sl_detail_text}
                        </p>

                        {/* Conditionally render buttons */}
                        {slider.sl_readme_link && slider.sl_readme_link.trim() !== "" && (
                          <Link
                            to={slider.sl_readme_link}
                            className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"
                          >
                            Read More
                          </Link>
                        )}

                        {slider.sl_apply_link && slider.sl_apply_link.trim() !== "" && (
                          <Link
                            to={slider.sl_apply_link}
                            className="btn btn-light py-md-3 px-md-5 animated slideInRight"
                          >
                            Join Now
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>


  {/* <!-- Service Start --> */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-4 justify-content-center">
            <div className="col-lg-6 col-sm-6 wow fadeInUp " data-wow-delay="0.1s">
              <div className="service-item text-center pt-3">
                <div className="p-4">
                  <i className="fa fa-3x fa-graduation-cap text-primary mb-4"></i>
                  <h5 className="mb-3">Vision</h5>
                  <p>Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita amet diam</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="service-item text-center pt-3">
                <div className="p-4">
                  <i className="fa fa-3x fa-globe text-primary mb-4"></i>
                  <h5 className="mb-3">Mission</h5>
                  <p>Diam elitr kasd sed at elitr sed ipsum justo dolor sed clita amet diam</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Service End --> */}

      {/* <!-- Notable Alumnis Start --> */}
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="text-center">
            <h6 className="section-title bg-white text-center text-primary px-3">Prominent Alumni's</h6>
          </div>
          <center>
            <div className="owl-carousel   team-carousel position-relative">
              <div className="testimonial-item text-center" style={{ width: '250px' }}>
                <div className="team-item bg-light">
                  <div className="overflow-hidden">
                    <img className="img-fluid" src="assets/img/team-1.jpg" alt="" />
                  </div>
                  <div className="position-relative d-flex justify-content-center" style={{ marginTop: '-23px' }}>
                    {/* <div className="bg-light d-flex justify-content-center pt-2 px-1">
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-facebook-f"></i></a>
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-twitter"></i></a>
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-instagram"></i></a>
                    </div> */}
                  </div>
                  <div className="text-center p-4">
                    <h5 className="mb-0">Instructor Name</h5>
                    <small>Designation</small>
                  </div>
                </div>
              </div>
              <div className="testimonial-item text-center" style={{ width: '250px' }}>
                <div className="team-item bg-light">
                  <div className="overflow-hidden">
                    <img className="img-fluid" src="assets/img/team-2.jpg" alt="" />
                  </div>
                  <div className="position-relative d-flex justify-content-center" style={{ marginTop: '-23px' }}>
                    {/* <div className="bg-light d-flex justify-content-center pt-2 px-1">
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-facebook-f"></i></a>
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-twitter"></i></a>
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-instagram"></i></a>
                    </div> */}
                  </div>
                  <div className="text-center p-4">
                    <h5 className="mb-0">Instructor Name</h5>
                    <small>Designation</small>
                  </div>
                </div>
              </div>
              <div className="testimonial-item text-center" style={{ width: '250px' }}>
                <div className="team-item bg-light">
                  <div className="overflow-hidden">
                    <img className="img-fluid" src="assets/img/team-3.jpg" alt="" />
                  </div>
                  <div className="position-relative d-flex justify-content-center" style={{ marginTop: '-23px' }}>
                    {/* <div className="bg-light d-flex justify-content-center pt-2 px-1">
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-facebook-f"></i></a>
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-twitter"></i></a>
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-instagram"></i></a>
                    </div> */}
                  </div>
                  <div className="text-center p-4">
                    <h5 className="mb-0">Instructor Name</h5>
                    <small>Designation</small>
                  </div>
                </div>
              </div>
              <div className="testimonial-item text-center" style={{ width: '250px' }}>
                <div className="team-item bg-light">
                  <div className="overflow-hidden">
                    <img className="img-fluid" src="assets/img/team-4.jpg" alt="" />
                  </div>
                  <div className="position-relative d-flex justify-content-center" style={{ marginTop: '-23px' }}>
                    {/* <div className="bg-light d-flex justify-content-center pt-2 px-1">
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-facebook-f"></i></a>
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-twitter"></i></a>
                      <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="fab fa-instagram"></i></a>
                    </div> */}
                  </div>
                  <div className="text-center p-4">
                    <h5 className="mb-0">Instructor Name</h5>
                    <small>Designation</small>
                  </div>
                </div>
              </div>
            </div>
          </center>
        </div>
      </div>
      {/* <!-- Notable Alumnis  End --> */}


      <AlumniSays />





    </>
  );
};

export default Home;
